import { fromUTC } from "helpers/dates";
import moment from "moment";
import React from "react";
import DatePicker from "material-ui/DatePicker";
import { v4 as uuidv4 } from 'uuid';

export default function RangeDates({ from, until, minDate, handleChangeDate }) {

    return (
        <div>
            <DatePicker 
                name={uuidv4()}
                autoOk
                minDate={minDate}
                // maxDate={until ? new Date(until) : undefined}
                onChange={(_, date) => handleChangeDate('lay', moment(date).utcOffset(0, true))}
                value={from ? fromUTC(from) : undefined}
                inputStyle={{ fontSize: '9px', cursor: 'pointer', textAlign: 'center' }}
                underlineStyle={{ display: 'none' }}
                textFieldStyle={{ width: 'unset', height: 'unset', lineHeight: 'unset' }}
            />
            <DatePicker 
                name={uuidv4()}
                autoOk
                minDate={from ? new Date(from) : undefined}
                onChange={(_, date) => {
                    return handleChangeDate('can', moment(date).utcOffset(0, true).set({ hour: 23, minute: 59, second: 59 }));
                }}
                inputStyle={{ fontSize: '9px', cursor: 'pointer', textAlign: 'center' }}
                value={until ? fromUTC(until) : undefined}
                underlineStyle={{ display: 'none' }}
                textFieldStyle={{ width: 'unset', height: 'unset', lineHeight: 'unset' }}
            />
        </div>
    );
}



// WEBPACK FOOTER //
// ./app/components/TcIndex/Basic/RangeDates.jsx